import React, { useState, useEffect } from 'react'
import HilfeSidebar from './hilfe/HilfeSidebar'
import Faqs from './settings/Faqs'
import Support from './hilfe/Support'

const Hilfe = () => {
  const [selectedComponent, setSelectedComponent] = useState('faqs');

  useEffect(() => {
    // Block scroll for hilfe page
    document.body.classList.add('block-scroll');
    return () => {
      document.body.classList.remove('block-scroll');
    };
  }, []);

  return (
    <div className="flex" style={{ height: 'calc(100vh - 50px)' }}>
      <div style={{ position: 'sticky', top: 0, height: '100vh', zIndex: 10 }}>
        <HilfeSidebar onSelect={setSelectedComponent} selectedComponent={selectedComponent} />
      </div>
      <div className='flex-grow p-4 overflow-y-auto' style={{ height: '100vh' }}>
        {selectedComponent === 'faqs' && <Faqs />}
        {selectedComponent === 'support' && <Support />}
      </div>
    </div>
  )
}

export default Hilfe
